import { LANDSCAPE_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/landscapeBackdrops';
import { forestBiome } from '../biomeArchetypes';
import { BRANCH_DEPTH_BACKDROPS, BRANCH_DEPTH_HEIGHTS } from '../../../game/effects/atmosphere/silhouettes/branchDepthBackdrops';

/**
 * Moonfen Pasture — moonlit marshy pasture branching from Tidewend Outskirts.
 *
 * Cold night sky gradient with pale moon and low cloud drift, motes of pale teal
 * and warm lantern ember, dim moonbeams, fen floor glow, and distant moor ridges.
 */
export const MOONFEN_PASTURE = forestBiome({
  id: 'moonfen_pasture',
  sky: { from: 0x07111a, to: 0x1c3038, bands: 6 },
  celestial: { atX: 0.78, atY: 0.16, color: 0xc4d8d2, haloColor: 0x6e9088, size: 56, haloScale: 3, coreAlpha: 0.65, haloAlpha: 0.12 },
  cloudBands: { count: 3, color: 0x485e62, sizeMin: 400, sizeMax: 700, alphaMin: 0.05, alphaMax: 0.12, driftPxPerSec: 4, bandYMin: 0.08, bandYMax: 0.34 },
  motes: { colors: [0xa8d4a0, 0x76b8a8, 0xdfb468], count: 8, sizeMin: 2, sizeMax: 5, driftPx: 26, periodMinMs: 8000, periodMaxMs: 15000, alphaMin: 0.12, alphaMax: 0.40 },
  rays: { color: 0x82a8a0, count: 1, widthMin: 70, widthMax: 130, height: 480, tiltDeg: 6, periodMinMs: 14000, periodMaxMs: 22000, alphaMin: 0.03, alphaMax: 0.08 },
  glow: {
    blobs: [
      { color: 0x5a887a, atX: 0.35, atY: 0.88, size: 360, alpha: 0.06 },
      { color: 0xb08848, atX: 0.68, atY: 0.75, size: 200, alpha: 0.05 },
    ],
    breathe: { periodMs: 8000, min: 0.78, max: 1.15 },
  },
  lightField: { palette: [0x5a887a, 0x426860, 0x887248], count: 4, sizeMin: 70, sizeMax: 150, alphaMin: 0.02, alphaMax: 0.06, driftRadius: 36, periodMinMs: 12000, periodMaxMs: 20000 },
  weather: { mode: 'fall', color: 0x748e8c, colorEnd: 0x3a4f4e, size: 3, frequencyMs: 760, lifespanMs: 3400, speed: 13, gravityY: 4, windX: 20, alphaEnd: 0.20, gust: { periodMs: 10000, min: 0.5, max: 1.2, phase: 0.2 } },
  flicker: { color: 0xd89c44, size: 160, baseAlpha: 0.06, flickerAmp: 0.035, hzMin: 1.5, hzMax: 3.2, anchors: [{ atX: 0.20, atY: 0.76 }, { atX: 0.65, atY: 0.72 }] },
  parallax: [
    { svg: BRANCH_DEPTH_BACKDROPS.moonfen, shape: 'dunes', color: 0x29454a, speed: 0.04, height: BRANCH_DEPTH_HEIGHTS.moonfen, alpha: 0.48, detail: 0.6, sway: { ampPx: 6, periodMs: 36000 } },
    { svg: LANDSCAPE_BACKDROPS.marsh.mid, shape: 'ridge', color: 0x13242a, speed: 0.10, height: 180, alpha: 0.82, detail: 0.9 },
    { svg: LANDSCAPE_BACKDROPS.marsh.near, shape: 'ridge', color: 0x0a161c, speed: 0.18, height: 110, alpha: 0.94, detail: 0.9 },
  ],
  fog: { color: 0x466064, bands: 4, alphaMin: 0.06, alphaMax: 0.14, driftPx: 38, periodMinMs: 12000, periodMaxMs: 22000, yMin: 0.60, yMax: 0.92, sizeMin: 220, sizeMax: 440 },
  closer: {
    vignette: { color: 0x02070a, edgeAlpha: 0.36, washColor: 0x0d1f24, washAlpha: 0.05 },
    grade: { top: 0x36545c, bottom: 0x102228, strength: 0.15, bands: 4, blend: 'normal' },
  },
});
